module.exports = __webpack_public_path__ + "media/images/arrow-right-3c58412a07e180148bf4e92c11f1ce0e.svg";